import { LoadState } from "../../constants/enums";
import { ILawyeredChallan, ILawyeredState } from "./lawyered.types";

export const initialLawyeredChallan: ILawyeredChallan = {
  lawyered_challan_uuid: "",
  username: "",
  mobile: "",
  vehicle_number: "",
  rc_details: {},
  rc_details_history: [],
  challan_details: {},
  challan_details_history: [],
  payment_done: 0,
  payment_date: null,
  lawyered_payment_response: {},
  awyered_payment_response_status: null,
  lawyered_challan_status: null,
  remarks: "",
  status: "ACTIVE",
  company_outlet_uuid: null,
  created_by_uuid: null,
  modified_by_uuid: null,
  create_ts: "",
  insert_ts: "",
};

export const initialLawyeredState: ILawyeredState = {
  lawyeredChallan: {
    list: {
      list: [],
      totalRecords: 0,
      loading: LoadState.NotLoaded,
      error: null,
    },
    data: {
      data: null,
      loading: LoadState.NotLoaded,
      error: null,
    },
  },
};
